export const SSPollQuestionText = ({ question }: { question: string }) => {
    return (
        <div className="border-b border-primary pb-2 pr-14" data-testid="PollQuestionText">
            {question}
        </div>
    );
};
